import {
  READ_MESSAGE_START,
  READ_MESSAGE_SUCCESS,
  READ_MESSAGE_ERROR,
} from '../../constants';
import { readMessage as mutation, countQuery, UnreadThreadsQuery, InboxQuery } from '../../lib/graphql';

export function readMessage(threadId, threadType) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: READ_MESSAGE_START,
    });

    try {
      // Send Message
      const { data } = await client.mutate({
        mutation,
        variables: {
          threadId
        },
        refetchQueries: [
          {
            query: countQuery
          },
          {
            query: UnreadThreadsQuery
          },
          {
            query: InboxQuery,
            variables: {
              threadId,
              threadType
            }
          }
        ]
      });

      if (data && data.sendMessage) {
        dispatch({
          type: READ_MESSAGE_SUCCESS,
        });
      }

    } catch (error) {
      dispatch({
        type: READ_MESSAGE_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}

